// extracted by mini-css-extract-plugin
export default {"descriptionToggleButton":"U9-z"};